<template>
  <div class="mx-md-auto my-md-auto pl-2 progress-circle" style="max-width: 120px;">
    <circle-counter size="8rem" :dash-count="100" :active-count="progressNumber" :stroke-width="10" :active-width="12" :active-stroke="progressColour" :stroke="backgroundColour" :text="progressNumber + '%'" :dash-spacing="0"/>
  </div>
</template>

<script>
import CircleCounter from 'vue-circle-counter';

export default {
  name: 'CircleProgress',
  components: {CircleCounter},
  props: ['progressNumber'],
  computed: {
    progressColour () {
      if (this.progressNumber <= 25) {
        return '#dc3545';
      } else if (this.progressNumber > 25 && this.progressNumber < 75) {
        return '#ffc107';
      } else if (this.progressNumber >= 75 && this.progressNumber < 100) {
        return '#28a745';
      } else if (this.progressNumber === 100) {
        return '#28a745';
      } else {
        return '#212A42';
      }
    },
    backgroundColour () {
      return this.progressNumber === 100 ? '#55a71c' : 'lightgrey'
    }
  }
};
</script>